import type { AddressFormState } from '@common/Checkout/Checkout/types/address';
import type { AddressReducer } from '@common/Checkout/Checkout/types/reducers';
import {
    RECEIVE_ADDRESS_FORM,
    SET_IS_EDITING_ADDRESS_FORM,
    UPDATE_ADDRESS_FORM,
    UPDATE_ADDRESS_MATCH_FIELD,
} from '../actions/constants';
import { ADDRESS_FORM } from '../constants';

const initialState: AddressFormState | undefined = {
    [ADDRESS_FORM.DELIVERY_ADDRESS]: [],
    [ADDRESS_FORM.BILLING_ADDRESS]: [],
    [ADDRESS_FORM.ADDRESS_MATCH]: null,
    isLoaded: false,
    isEditing: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: AddressReducer = (state = initialState, action) => {
    if (!state) return initialState;
    const { type } = action;

    switch (type) {
        case RECEIVE_ADDRESS_FORM: {
            const { payload } = action;

            return { ...state, ...payload, isLoaded: true };
        }

        case SET_IS_EDITING_ADDRESS_FORM: {
            const { payload } = action;
            return { ...state, isEditing: payload };
        }

        case UPDATE_ADDRESS_FORM: {
            const { payload } = action;
            const { formName, field, fieldIndex } = payload;

            // @ts-ignore
            const formFields = [...state[formName]];
            formFields[fieldIndex] = field;

            return {
                ...state,
                [formName]: formFields,
            };
        }

        case UPDATE_ADDRESS_MATCH_FIELD: {
            const { payload } = action;
            const field = state[ADDRESS_FORM.ADDRESS_MATCH];
            const updatedField = field ? { ...field, value: payload } : null;

            return {
                ...state,
                [ADDRESS_FORM.ADDRESS_MATCH]: updatedField,
            };
        }

        default:
            return state;
    }
};

export default reducer;
